.TabbedArea {
  display: flex;
  flex-direction: column;
  flex: 1 0 1rem;
  margin: 0 -2rem;
  padding: 0 2rem;
  overflow: hidden;
}

.TabPanelContainer {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}
